import template from './brandsUsers.html';
import './brandsUsers.scss';

export class BrandsUsersController {
  constructor() {
    this.searchQuery = '';
    this.usersList = [];
    this.selectedUsers = {};
    this.toggleAll = true;
    this.disableToggle = false;
    this.disableBulkActions = false;
  }
  handleHeaderAction(action) {
    this.onHeaderActionClicked({ action });
  }
  setSearchQuery(text) {
    this.searchQuery = text.toLowerCase();
    this.filterUsers();
  }
  filterUsers(resetSelection = false) {
    if (resetSelection) {
      this.copySelectionList();
    }

    if (this.searchQuery) {
      this.usersList = this.users.filter(({
        name,
        email,
      }) => name.toLowerCase().includes(this.searchQuery) ||
        email.toLowerCase().includes(this.searchQuery));
    } else {
      this.usersList = this.users || [];
    }

    this.updateToggleFlags();
  }
  copySelectionList() {
    this.selectedUsers = {};
    this.usersList.forEach((user) => {
      this.selectedUsers[user.id] = false;
    });
  }
  updateToggleFlags() {
    this.disableToggle = !this.usersList.length;
    if (this.disableToggle) {
      this.toggleAll = true;
    } else {
      const halfDivider = 2;
      const half = Math.round(this.usersList.length / halfDivider);
      const selected = Object.keys(this.selectedUsers)
      .filter((userId) => this.selectedUsers[userId])
      .length;
      this.toggleAll = selected < half;
      this.disableBulkActions = !selected;
    }
  }
  toggleList(select) {
    this.selectedUsers = {};
    this.toggleAll = !this.toggleAll;
    if (select) {
      this.usersList.forEach((user) => {
        this.selectedUsers[user.id] = true;
      });
    }

    this.updateToggleFlags();
  }
  revokeSelected() {
    this.onRevoke({ users: this.getSelectedUsers() });
  }
  revoke(user) {
    this.onRevoke({ users: [user] });
  }
  updateSelected() {
    this.onUpdate({ users: this.getSelectedUsers() });
  }
  update(user) {
    this.onUpdate({ users: [user] });
  }
  view(user) {
    this.onView({ user });
  }
  getSelectedUsers() {
    const ids = Object.keys(this.selectedUsers)
    .filter((userId) => this.selectedUsers[userId]);

    return this.usersList.filter((user) => ids.includes(user.id));
  }
  $onChanges({ brand, loading }) {
    if (
      brand &&
      brand.previousValue.id !== brand.currentValue.id
    ) {
      this.searchQuery = '';
    }

    if (loading && loading.previousValue && !loading.loadingCurrentValue) {
      this.filterUsers(true);
    }
  }
}

export default {
  controller: BrandsUsersController,
  template,
  bindings: {
    brand: '<',
    users: '<',
    currentUserId: '<',
    loading: '<',
    headerActions: '<',
    onHeaderActionClicked: '&',
    canUpdatePermissions: '<',
    onView: '&',
    onUpdate: '&',
    onRevoke: '&',
  },
};
